module.exports = __webpack_public_path__ + "img/02_L3.9ee37496.svg";